/**
 * The four parts of a teammate's time, in the order a moment is counted (busy first, idle last), each with the
 * status tone that colours it, that tone's colour, and the words that name it. `ZhTimeSplit` draws the bar from this
 * list and `ZhTimeSplitLegend` explains it, and both paint a part with its `colour` from here, so a colour and its
 * words can never drift apart: there is no second place the colour is written.
 */
export type TimeSplitPartKey = 'busy' | 'waitingOnYou' | 'waitingOnOther' | 'idle'

export type TimeSplitPart = {
    key: TimeSplitPartKey
    tone: 'running' | 'action' | 'neutral' | 'muted'
    /** The part's background, from the theme's state colours: the one definition the bar and the legend both use. */
    colour: string
    words: string
}

export const TIME_SPLIT_PARTS: readonly TimeSplitPart[] = [
    { key: 'busy', tone: 'running', colour: 'var(--state-active)', words: 'busy' },
    { key: 'waitingOnYou', tone: 'action', colour: 'var(--state-action)', words: 'waiting on you' },
    {
        key: 'waitingOnOther',
        tone: 'neutral',
        colour: 'var(--state-inactive)',
        words: 'waiting on another teammate or system',
    },
    {
        key: 'idle',
        tone: 'muted',
        colour: 'color-mix(in srgb, var(--state-inactive) 25%, transparent)',
        words: 'idle',
    },
]
